module.exports = __webpack_public_path__ + "img/DSC_0062.74706101.jpg";